<template>
  <apexchart
    v-bind="$attrs"
    v-on="$listeners"
    :type="type"
    :height="height"
    :width="width"
    :options="resolvedOptions"
    :series="resolvedSeries"
  ></apexchart>
</template>

<script>
import src from './src'
export default src
</script>
